import { LEVEL } from '../../../../../constant/level'
import { RATE_OF_PERCEIVED_EXERTION } from '../../../../../constant/rate-of-perceived-exertion'
import { UNIT } from '../../../../../constant/unit'
import { PROFILE_DEFAULT_WEIGHT_IN_KG } from '../../../../../models/profile/constants/fitness-data-keys'
import { WORKOUT_KEY } from '../../../../../modules/workout/model'
import { WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise/model'
import { SET_DATA_KEY } from '../../../../workout-exercise/model/constants'
import {
  getEstimatedRateOfPerceivedExertionSetDataUtil,
  getRepsFromDurationSetDataUtil,
  getSetDurationSetDataUtil
} from '../../../../workout-exercise/model/utils'
import getWorkoutExercisesWorkoutSectionUtil from '../../../../workout-section/model/utils/get-workout-exercises'
import {
  EXERCISE_KEY,
  EXERCISE_TYPE_TO_METABOLIC_EQUIVALENT,
  getEquipmentExerciseUtil,
  getTypeExerciseUtil,
  METABOLIC_EQUIVALENT_DEFAULT
} from '../../../../exercise'
// import getByExerciseIdExerciseLogSummarySelector
//   from '../../../../exercise-log-summaries/selectors/get-by-exercise-id'
import getDomainMapExercisesSelect from '../../../../exercise/redux/selectors/get-domain-map'
import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getCurrentProfileSelect } from '../../../../profile/redux/selectors/get-current'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import { getWeightProfileSelect } from '../../../../profile/redux/selectors/get-weight'
import { getWeightUnitProfileSelect } from '../../../../profile/redux/selectors/get-weight-unit'
import { getChangedKeyPathReduxUtil } from '../../../../redux/utils/get-foreign-key-reference-path'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getInstance from '../../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import isTemporaryIdReduxUtil from '../../../../redux/utils/is-temporary-id'
import { setIdReduxUtil } from '../../../../redux/utils/set-id'
import updateReduxUtil from '../../../../redux/utils/update'
import WORKOUT_EXERCISES_PATH from '../../../../workout-exercise/redux/constants/path'
import WORKOUT_SECTIONS_PATH from '../../../../workout-section/redux/constants/path'
import { toFixedFloatNumberUtil } from '../../../../../utils/number/to-fixed-float'
import { toIntNumberUtil } from '../../../../../utils/number/to-int'
import { compactObjectUtil, getObjectUtil, isEmptyUtil } from 'packages/src'

import setUtil from '../../../../../utils/set'
import { getKgsWeightUtil } from '../../../../../modules/weight/utils/get-kgs'
import { getLbsWeightUtil } from '../../../../../modules/weight/utils/get-lbs'
import getWorkoutSectionsWorkoutUtil from '../get-workout-sections'
import isBodyWeightExerciseUtil from '../../../../exercise/model/utils/is-body-weight'
import { getMusclesExerciseUtil } from '../../../../exercise/model/utils/get-muscles'
import { getSecondaryMusclesExerciseUtil } from '../../../../exercise/model/utils/get-secondary-muscles'
import hasLoadedAssociationsReduxUtil from '../../../../redux/utils/has-loaded-associations'

export default function updateDataWorkoutUtil (params) {
  if (!hasLoadedAssociationsReduxUtil(params.workout)) {
    return params.state
  }

  const {
    duration,
    muscleToDuration,
    secondaryMuscleToDuration,
    equipmentToDuration,
    exerciseLevelToCount,
    effectiveSetsCount,
    exerciseTypeToDuration,
    estimatedMetabolicEquivalentsArr,
    estimatedTrainingVolume
  } = getDataFromWorkoutExercises(params)

  let updates = compactObjectUtil({
    [WORKOUT_KEY.DURATION]: duration,
    [WORKOUT_KEY.MUSCLES]: muscleToDuration,
    [WORKOUT_KEY.SECONDARY_MUSCLES]: secondaryMuscleToDuration,
    [WORKOUT_KEY.EQUIPMENT]: equipmentToDuration, // @see {@link
    // https://medium.com/@SandCResearch/what-is-training-volume-286b8da6f427}
    [WORKOUT_KEY.ESTIMATED_TRAINING_VOLUME]: estimatedTrainingVolume,
    [WORKOUT_KEY.LEVEL]: getLevel(exerciseLevelToCount, effectiveSetsCount),
    [WORKOUT_KEY.TYPES]: exerciseTypeToDuration
  }, (val) => {
    if (typeof val === 'object') {
      return isEmptyUtil(val)
    }
    return val == null
  })

  const exercisesCount = estimatedMetabolicEquivalentsArr.length
  if (duration && exercisesCount) {
    params = {
      ...params,
      updates,
      duration,
      estimatedMetabolicEquivalentsArr,
      exercisesCount
    }
    updates = updateCalories(params)
  }
  return setUtil(params.state,
    getPathReduxUtil(params.workout),
    updateReduxUtil(params.workout, updates)
  )
}

// TODO take in consideration 1RM
function getLevel (exerciseLevelToCount, effectiveSetsCount) {
  let maxExerciseLevel
  let maxCount = 0
  Object.keys(exerciseLevelToCount)
    .forEach(exerciseLevel => {
      const count = exerciseLevelToCount[exerciseLevel]
      if (count > maxCount) {
        maxExerciseLevel = exerciseLevel
        maxCount = count
      }
    })

  let level
  if (effectiveSetsCount >= 25) {
    level = LEVEL.EXPERT
  } else if (effectiveSetsCount >= 20) {
    level = LEVEL.ADVANCED
  } else if (effectiveSetsCount >=
    15 &&
    maxExerciseLevel >
    LEVEL.INTERMEDIATE) {
    level = LEVEL.ADVANCED
  } else if (effectiveSetsCount >= 15) {
    level = LEVEL.INTERMEDIATE
  } else if (effectiveSetsCount >=
    10 &&
    maxExerciseLevel >
    LEVEL.INTERMEDIATE) {
    level = LEVEL.INTERMEDIATE
  } else {
    level = LEVEL.BEGINNER
  }

  return level
}

function getKeyToSetDataDurationMapFromList (obj, arr, setDataDuration) {
  arr.forEach(key => getKeyToSetDataDurationMap(obj, key, setDataDuration))
}

function getKeyToSetDataDurationMap (obj, key, setDataDuration) {
  if (!obj[key]) {
    obj[key] = 0
  }
  obj[key] += setDataDuration
}

function getSetDataStats (params) {
  const exerciseLogSummary = null // TODO omit after adding exercise logs domain to `web`
  // (
  //   getByExerciseIdExerciseLogSummarySelector(getIdReduxUtil(params.exercise))(
  //     params.state)
  // )

  let setDataEffectiveSetCount = 0
  let setDataEffectiveTrainingVolumeSetCount = 0
  const setDataDuration = params.setData.reduce((setDataDuration, set) => {
    const setDuration = getSetDurationSetDataUtil(set)
    const rpe = getEstimatedRateOfPerceivedExertionSetDataUtil({
      exerciseLogSummary,
      set,
      workoutSection: params.workoutSection,
      exercise: params.exercise
    })

    if (rpe >= RATE_OF_PERCEIVED_EXERTION.MODERATE) {
      setDataEffectiveSetCount += 1
      const weight = set[SET_DATA_KEY.WEIGHT]
      const weightUnit = (
        set[SET_DATA_KEY.WEIGHT_UNIT] ||
        params.profileWeightUnit ||
        UNIT.IMPERIAL
      )

      let weightInLbs
      if (!weight &&
        isBodyWeightExerciseUtil(params.exercise) &&
        params.profileWeight) {
        weightInLbs = getLbsWeightUtil(
          params.profileWeight,
          params.profileWeightUnit
        )
      } else if (!weight) {
        weightInLbs = 1
      } else {
        weightInLbs = getLbsWeightUtil(weight, weightUnit)
      }

      const reps = getRepsFromDurationSetDataUtil(setDuration)
      setDataEffectiveTrainingVolumeSetCount += Math.round((
        reps * weightInLbs
      ))
    }
    return setDataDuration + setDuration
  }, 0)

  return {
    setDataDuration,
    setDataEffectiveSetCount,
    setDataEffectiveTrainingVolumeSetCount
  }
}

function getDataFromWorkoutExercises (params) {
  const workoutSectionPointers = (
    getWorkoutSectionsWorkoutUtil(params.workout)
  )
  const workoutSectionsDomainMap = getObjectUtil(params.state, WORKOUT_SECTIONS_PATH.DATA)
  const workoutExercisesDomainMap = getObjectUtil(params.state,
    WORKOUT_EXERCISES_PATH.DATA
  )

  const profileWeight = getWeightProfileSelect(params.state)
  const profileWeightUnit = getWeightUnitProfileSelect(params.state)

  const exerciseDomainMap = getDomainMapExercisesSelect(params.state)
  const secondaryMuscleToDuration = {}
  const muscleToDuration = {}
  const equipmentToDuration = {}
  let duration = 0
  const exerciseLevelToCount = {}
  const exerciseTypeToDuration = {}
  let effectiveSetsCount = 0
  let estimatedTrainingVolume = 0
  const estimatedMetabolicEquivalentsArr = []

  workoutSectionPointers.forEach((workoutSectionPointer, workoutSectionIndex) => {
    const workoutSectionId = getIdReduxUtil(workoutSectionPointer)
    const workoutSection = workoutSectionsDomainMap[workoutSectionId]
    const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
      workoutSection)

    // TODO omit - used to add profile id
    const workoutSectionProfileId = getValueReduxUtil(workoutSection,
      WORKOUT_EXERCISE_KEY.PROFILE_ID
    )
    if (!workoutSectionProfileId) {
      const newWorkoutSection = updateReduxUtil(workoutSection, {
        [WORKOUT_EXERCISE_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(
          params.state)
      })
      params.state = setUtil(params.state,
        getPathReduxUtil(newWorkoutSection),
        newWorkoutSection
      )
    }
    const newWorkoutSection = updateReduxUtil(getInstance(
      params.state,
      workoutSection
    ), {
      [WORKOUT_EXERCISE_KEY.ORDER]: workoutSectionIndex + 1
    })
    params.state = setUtil(params.state,
      getPathReduxUtil(newWorkoutSection),
      newWorkoutSection
    )

    workoutExercisePointers.forEach((workoutExercisePointer, index) => {
      const workoutExerciseId = getIdReduxUtil(workoutExercisePointer)
      const workoutExercise = workoutExercisesDomainMap[workoutExerciseId]
      const setData = getValueReduxUtil(workoutExercise,
        WORKOUT_EXERCISE_KEY.SET_DATA
      )
      const exerciseId = getValueReduxUtil(workoutExercise,
        WORKOUT_EXERCISE_KEY.EXERCISE_ID
      )

      // TODO omit
      // Used to fix timer HIIT interval
      const newWorkoutExercise = updateReduxUtil(workoutExercise, {
        [WORKOUT_EXERCISE_KEY.ORDER]: index + 1
      })
      params.state = setUtil(params.state,
        getPathReduxUtil(newWorkoutExercise),
        newWorkoutExercise
      )

      // TODO omit - used to add profile id
      const workoutExerciseProfileId = getValueReduxUtil(workoutExercise,
        WORKOUT_EXERCISE_KEY.PROFILE_ID
      )
      if (!workoutExerciseProfileId) {
        const newWorkoutExercise = updateReduxUtil(workoutExercise, {
          [WORKOUT_EXERCISE_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(
            params.state)
        })
        params.state = setUtil(params.state,
          getPathReduxUtil(newWorkoutExercise),
          newWorkoutExercise
        )
      }

      // TODO omit - used to add workout id
      const workoutId = getValueReduxUtil(workoutExercise,
        WORKOUT_EXERCISE_KEY.WORKOUT_ID
      )
      if (!workoutId || isTemporaryIdReduxUtil(workoutId)) {
        params.state = setIdReduxUtil({
          state: params.state,
          instance: params.workout,
          path: getChangedKeyPathReduxUtil(
            workoutExercise,
            WORKOUT_EXERCISE_KEY.WORKOUT_ID
          )
        })
      }

      const exercise = exerciseDomainMap[exerciseId]
      const exerciseLevel = (
        getValueReduxUtil(exercise, EXERCISE_KEY.LEVEL) || LEVEL.BEGINNER
      )
      const exerciseLevelCount = exerciseLevelToCount[exerciseLevel] || 0
      exerciseLevelToCount[exerciseLevel] = exerciseLevelCount + 1
      const {
        setDataDuration,
        setDataEffectiveSetCount,
        setDataEffectiveTrainingVolumeSetCount
      } = getSetDataStats({
        state: params.state,
        setData,
        workoutSection,
        exercise,
        profileWeight,
        profileWeightUnit
      })
      duration += setDataDuration
      effectiveSetsCount += setDataEffectiveSetCount
      estimatedTrainingVolume += setDataEffectiveTrainingVolumeSetCount

      if (!exercise) {
        return
      }

      const exerciseMuscles = getMusclesExerciseUtil(exercise)
      const exerciseSecondaryMuscles = getSecondaryMusclesExerciseUtil(exercise)
      const secondaryMusclesCount = Object.keys(exerciseSecondaryMuscles).length
      const primaryMusclesCount = Object.keys(exerciseMuscles).length
      const durationPerSecondaryMuscle = secondaryMusclesCount
        ? (
            setDataDuration / secondaryMusclesCount
          ) / 2
        : 0
      const durationPerPrimaryMuscle = primaryMusclesCount
        ? (
            setDataDuration / primaryMusclesCount
          ) -
        (
          durationPerSecondaryMuscle * secondaryMusclesCount
        )
        : setDataDuration

      getKeyToSetDataDurationMapFromList(muscleToDuration,
        exerciseMuscles,
        durationPerPrimaryMuscle
      )

      getKeyToSetDataDurationMapFromList(secondaryMuscleToDuration,
        exerciseSecondaryMuscles,
        durationPerSecondaryMuscle
      )

      const exerciseEquipment = getEquipmentExerciseUtil(exercise)
      getKeyToSetDataDurationMapFromList(equipmentToDuration,
        exerciseEquipment,
        setDataDuration
      )

      const exerciseType = getTypeExerciseUtil(exercise)
      getKeyToSetDataDurationMap(exerciseTypeToDuration,
        exerciseType,
        setDataDuration
      )

      estimatedMetabolicEquivalentsArr.push(// TODO put back
        // getValueReduxUtil(exercise, EXERCISE_KEY.METABOLIC_EQUIVALENT) ||
        EXERCISE_TYPE_TO_METABOLIC_EQUIVALENT[exerciseType] ||
        METABOLIC_EQUIVALENT_DEFAULT)
    })
  })

  return {
    duration,
    muscleToDuration,
    secondaryMuscleToDuration,
    equipmentToDuration,
    exerciseLevelToCount,
    effectiveSetsCount,
    exerciseTypeToDuration,
    estimatedMetabolicEquivalentsArr,
    estimatedTrainingVolume
  }
}

function updateCalories (params) {
  const {
    workout,
    updates,
    state,
    duration,
    estimatedMetabolicEquivalentsArr,
    exercisesCount
  } = params

  // Calculate metabolic equivalent
  // weight (kg) * MET = calories burned per hour
  // @see {@link https://en.wikipedia.org/wiki/Metabolic_equivalent_of_task}
  const profile = getCurrentProfileSelect(state)
  const weight = getValueReduxUtil(profile, PROFILE_KEY.WEIGHT)
  const weightUnit = getValueReduxUtil(profile, PROFILE_KEY.WEIGHT_UNIT)
  const profileWeight = weight
    ? getKgsWeightUtil(weight, weightUnit)
    : PROFILE_DEFAULT_WEIGHT_IN_KG
  let metabolicEquivalent = getValueReduxUtil(
    workout,
    WORKOUT_KEY.METABOLIC_EQUIVALENT
  )
  if (!metabolicEquivalent) {
    metabolicEquivalent = estimatedMetabolicEquivalentsArr.reduce((total, val) => {
      return total + val
    }, 0) / exercisesCount
  }
  const estimatedCaloriesPerHour = (
    profileWeight * metabolicEquivalent
  )
  const oneHourDurationInSeconds = 3600
  // 3600 -> `oneHourDurationInSeconds`
  // `duration` -> ? = `estimatedCalories`
  const estimatedCalories = Math.round((
    duration * estimatedCaloriesPerHour
  ) / oneHourDurationInSeconds)

  return {
    ...updates,
    [WORKOUT_KEY.ESTIMATED_METABOLIC_EQUIVALENT]: toFixedFloatNumberUtil(
      metabolicEquivalent,
      2
    ),
    [WORKOUT_KEY.ESTIMATED_CALORIES]: toIntNumberUtil(estimatedCalories)
  }
}
